"use strict";
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _SHDate_instances, _a, _SHDate_date, _SHDate_sh, _SHDate_config, _SHDate_dateSync, _SHDate_timeSync, _SHDate_GregorianToSolar, _SHDate_SolarToGregorian, _SHDate_GDayOfYear, _SHDate_GDateOfDayOfYear, _SHDate_GDaysInMonths, _SHDate_GDaysInYear, _SHDate_GIsLeapYear, _SHDate_isLeapYear, _SHDate_dayOfWeek, _SHDate_nthWeekdayOfMonth, _SHDate_WeekdayInMonth, _SHDate_dayOfYear, _SHDate_weekOfYear, _SHDate_weeksInYear, _SHDate_weekOfDay, _SHDate_dateOfDayOfYear, _SHDate_daysInMonth, _SHDate_daysInYear, _SHDate_getDates, _SHDate_setFullYear, _SHDate_setMonth, _SHDate_setDate, _SHDate_setHours, _SHDate_setMinutes, _SHDate_setSeconds, _SHDate_setMilliseconds, _SHDate_restTime, _SHDate_isFalse;
var SHDateLanguages;
(function (SHDateLanguages) {
    SHDateLanguages["fa_IR"] = "fa_IR";
    SHDateLanguages["en_US"] = "en_US";
    SHDateLanguages["ckb_IR"] = "ckb_IR";
})(SHDateLanguages || (SHDateLanguages = {}));
class SHDateLanguage {
    static check(language) {
        return Object.values(SHDateLanguages).includes(language);
    }
    static getClass(language) {
        switch (language) {
            case SHDateLanguages.fa_IR:
                return SHDateLanguage_fa_IR;
            case SHDateLanguages.en_US:
                return SHDateLanguage_en_US;
            case SHDateLanguages.ckb_IR:
                return SHDateLanguage_ckb_IR;
            default:
                return SHDateLanguage.getClass(SHDateLanguage.LANGUAGE);
        }
    }
}
SHDateLanguage.LANGUAGE = SHDateLanguages.en_US;
class SHDateLanguage_en_US {
    static SuffixNames(num) {
        if (!Number.isInteger(num)) {
            throw new Error("The value is not integer");
        }
        if (num >= 10 && num <= 19)
            return SHDateLanguage_en_US.SUFFIX[0];
        switch (num % 10) {
            case 1:
                return SHDateLanguage_en_US.SUFFIX[1];
            case 2:
                return SHDateLanguage_en_US.SUFFIX[2];
            case 3:
                return SHDateLanguage_en_US.SUFFIX[3];
            default:
                return SHDateLanguage_en_US.SUFFIX[0];
        }
    }
}
SHDateLanguage_en_US.LANGUAGE = "en_US";
SHDateLanguage_en_US.DIGIT = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "."
];
SHDateLanguage_en_US.SUFFIX = ["th", "st", "nd", "rd"];
SHDateLanguage_en_US.MERIDIEN_FULL_NAMES = ["AM", "PM"];
SHDateLanguage_en_US.MERIDIEN_SHORT_NAMES = ["am", "pm"];
SHDateLanguage_en_US.MONTH_FULL_NAMES = [
    "Farvardin",
    "Ordibehesht",
    "Khordad",
    "Tir",
    "Amordad",
    "Shahrivar",
    "Mehr",
    "Aban",
    "Azar",
    "Dey",
    "Bahman",
    "Esfand"
];
SHDateLanguage_en_US.MONTH_SHORT_NAMES = [
    "Far",
    "Ord",
    "Kho",
    "Tir",
    "Amo",
    "Sha",
    "Meh",
    "Aba",
    "Aza",
    "Dey",
    "Bah",
    "Esf"
];
SHDateLanguage_en_US.DAY_FULL_NAMES = [
    "Saturday",
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday"
];
SHDateLanguage_en_US.DAY_SHORT_NAMES = [
    "Sat",
    "Sun",
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri"
];
SHDateLanguage_en_US.CONSTELLATIONS_FULL_NAMES = [
    "Aries",
    "Taurus",
    "Gemini",
    "Cancer",
    "Leo",
    "Virgo",
    "Libra",
    "Scorpio",
    "Sagittarius",
    "Capricorn",
    "Aquarius",
    "Pisces"
];
SHDateLanguage_en_US.ANIMALS_FULL_NAMES = [
    "Snake",
    "Horse",
    "Sheep",
    "Monkey",
    "Chicken",
    "Dog",
    "Pig",
    "Mouse",
    "Cow",
    "Panther",
    "Rabbit",
    "Whale"
];
SHDateLanguage_en_US.SEASON_FULL_NAMES = [
    "Spring",
    "Summer",
    "Fall",
    "Winter"
];
SHDateLanguage_en_US.SOLSTICE_FULL_NAMES = ["Tammuz", "Yalda"];
class SHDateLanguage_fa_IR {
    static SuffixNames() {
        return SHDateLanguage_fa_IR.SUFFIX;
    }
}
SHDateLanguage_fa_IR.LANGUAGE = "fa_IR";
SHDateLanguage_fa_IR.DIGIT = [
    "٠",
    "١",
    "٢",
    "٣",
    "۴",
    "۵",
    "۶",
    "٧",
    "٨",
    "٩",
    ","
];
SHDateLanguage_fa_IR.SUFFIX = "ام";
SHDateLanguage_fa_IR.MERIDIEN_FULL_NAMES = ["قبل از ظهر", "بعد از ظهر"];
SHDateLanguage_fa_IR.MERIDIEN_SHORT_NAMES = ["ق‍.ظ", "ب‍.ظ"];
SHDateLanguage_fa_IR.MONTH_FULL_NAMES = [
    "فروردين",
    "ارديبهشت",
    "خرداد",
    "تير",
    "مرداد",
    "شهريور",
    "مهر",
    "آبان",
    "آذر",
    "دي",
    "بهمن",
    "اسفند"
];
SHDateLanguage_fa_IR.MONTH_SHORT_NAMES = [
    "فرو",
    "ارد",
    "خرد",
    "تير",
    "مرد",
    "شهر",
    "مهر",
    "آبا",
    "آذر",
    "دي",
    "بهم‍",
    "اسف‍"
];
SHDateLanguage_fa_IR.DAY_FULL_NAMES = [
    "شنبه",
    "يک‌شنبه",
    "دوشنبه",
    "سه ش‍‍‍‍نبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه"
];
SHDateLanguage_fa_IR.DAY_SHORT_NAMES = [
    "ش‍",
    "ی‍",
    "د",
    "س‍",
    "چ‍",
    "پ‍",
    "ج‍"
];
SHDateLanguage_fa_IR.CONSTELLATIONS_FULL_NAMES = [
    "حَمَل",
    "ثَور",
    "جَوزا",
    "سَرَطان",
    "اَسَد",
    "سُنبُله",
    "مِیزان",
    "عَقرَب",
    "قَوس",
    "جَدْی",
    "دَلو",
    "حوت"
];
SHDateLanguage_fa_IR.ANIMALS_FULL_NAMES = [
    "مار",
    "اسب",
    "گوسفند",
    "ميمون",
    "مرغ",
    "سگ",
    "خوک",
    "موش",
    "گاو",
    "پلنگ",
    "خرگوش",
    "نهنگ"
];
SHDateLanguage_fa_IR.SEASON_FULL_NAMES = [
    "بهار",
    "تابستان",
    "پاييز",
    "زمستان"
];
SHDateLanguage_fa_IR.SOLSTICE_FULL_NAMES = ["تموز", "يلدا"];
class SHDateLanguage_ckb_IR {
    static SuffixNames() {
        return SHDateLanguage_ckb_IR.SUFFIX;
    }
}
SHDateLanguage_ckb_IR.LANGUAGE = "ckb_IR";
SHDateLanguage_ckb_IR.DIGIT = [
    "٠",
    "١",
    "٢",
    "٣",
    "۴",
    "۵",
    "۶",
    "٧",
    "٨",
    "٩",
    ","
];
SHDateLanguage_ckb_IR.DIGIT2 = [
    "٠",
    "١",
    "٢",
    "٣",
    "٤",
    "٥",
    "٦",
    "٧",
    "٨",
    "٩",
    ","
];
SHDateLanguage_ckb_IR.SUFFIX = "ام";
SHDateLanguage_ckb_IR.MERIDIEN_FULL_NAMES = ["پێش زایین", "زایینی"];
SHDateLanguage_ckb_IR.MERIDIEN_SHORT_NAMES = ["ب.ن", "د.ن"];
SHDateLanguage_ckb_IR.MONTH_FULL_NAMES = [
    "کانوونی دووەم",
    "شوبات",
    "ئازار",
    "نیسان",
    "ئایار",
    "حوزەیران",
    "تەمووز",
    "ئاب",
    "ئەیلوول",
    "تشرینی یەکەم",
    "تشرینی دووەم",
    "کانونی یەکەم"
];
SHDateLanguage_ckb_IR.MONTH_SHORT_NAMES = [];
SHDateLanguage_ckb_IR.DAY_FULL_NAMES = [
    "یەکشەممە",
    "دووشەممە",
    "سێشەممە",
    "چوارشەممە",
    "پێنجشەممە",
    "ھەینی",
    "شەممە"
];
SHDateLanguage_ckb_IR.DAY_SHORT_NAMES = ["ی", "د", "س", "چ", "پ", "ھ", "ش"];
SHDateLanguage_ckb_IR.CONSTELLATIONS_FULL_NAMES = [
    "حَمَل",
    "ثَور",
    "جَوزا",
    "سَرَطان",
    "اَسَد",
    "سُنبُله",
    "مِیزان",
    "عَقرَب",
    "قَوس",
    "جَدْی",
    "دَلو",
    "حوت"
];
SHDateLanguage_ckb_IR.ANIMALS_FULL_NAMES = [
    "مار",
    "اسب",
    "گوسفند",
    "ميمون",
    "مرغ",
    "سگ",
    "خوک",
    "موش",
    "گاو",
    "پلنگ",
    "خرگوش",
    "نهنگ"
];
SHDateLanguage_ckb_IR.SEASON_FULL_NAMES = [
    "بهار",
    "تابستان",
    "پاييز",
    "زمستان"
];
SHDateLanguage_ckb_IR.SOLSTICE_FULL_NAMES = ["تموز", "يلدا"];
class SHDateLexer {
    constructor(input) {
        this.input = input;
        this.reset();
        this.tokens = SHDateLexer.scan(input);
        this.moveNext();
    }
    static scan(input) {
        let tokens = [];
        let offset, position = 0;
        let i = input.length;
        const tokenDefinitions = Object.entries(SHDateLexer.tokenDefinitions);
        while (i-- >= 0) {
            let anyMatch = false;
            for (const [tokenName, tokenRegex] of tokenDefinitions) {
                const Regex = new RegExp("^" + tokenRegex, "i");
                const match = Regex.exec(input);
                if (match !== null) {
                    const len = match[0].length;
                    if (tokenName.length > 0) {
                        tokens.push(new SHDateToken(tokenName, match[0], offset, position, len));
                        position++;
                    }
                    input = input.substr(len);
                    anyMatch = true;
                    offset += len;
                    break;
                }
            }
            if (!anyMatch) {
            }
        }
        return tokens;
    }
    getInput() {
        return this.input;
    }
    getPosition() {
        return this.position;
    }
    getLookahead() {
        return this.lookahead;
    }
    getToken() {
        return this.token;
    }
    reset() {
        this.position = 0;
        this.peek = 0;
        this.token = null;
        this.lookahead = null;
    }
    resetPeek() {
        this.peek = 0;
    }
    resetPosition(position = 0) {
        this.position = position - 1;
        this.moveNext();
    }
    isNextToken(tokenName) {
        return this.lookahead !== false && this.lookahead.getName() === tokenName;
    }
    isNextTokenAny(tokenNames) {
        return (this.lookahead !== false &&
            tokenNames.find((value) => value == this.lookahead.getName()));
    }
    moveNext() {
        this.peek = 0;
        this.token = this.lookahead;
        if (typeof this.tokens[this.position] !== "undefined") {
            this.lookahead = this.tokens[this.position++];
            return true;
        }
        return (this.lookahead = false);
    }
    skipUntil(tokenName) {
        while (this.lookahead !== false && this.lookahead.getName() !== tokenName) {
            this.moveNext();
        }
    }
    skipTokens(tokenNames) {
        while (this.lookahead !== false &&
            tokenNames.find((value) => value == this.lookahead.getName())) {
            this.moveNext();
        }
    }
    peeks() {
        if (typeof this.tokens[this.position + this.peek] !== "undefined")
            return this.tokens[this.position + this.peek++];
        return false;
    }
    peekWhileTokens(tokenNames) {
        let token = this.peeks();
        while (token) {
            if (!tokenNames.find((value) => value == token.getName())) {
                break;
            }
        }
        return token;
    }
    glimpse() {
        let peek = this.peeks();
        this.peek = 0;
        return peek;
    }
}
SHDateLexer.SINGLE_QUOTE = `\\'`;
SHDateLexer.COMMA = `,`;
SHDateLexer.DOT = `.`;
SHDateLexer.SPACE = `[ \t\\s]`;
SHDateLexer.tokenDefinitions = {
    SPACE: `${SHDateLexer.SPACE}`,
    DASH: `-`,
    PLUS: `\\+`,
    SLASH: `\\/`,
    COLON: ":",
    COMMA: ",",
    SINGLE_QUOTE: SHDateLexer.SINGLE_QUOTE,
    INT_00: "00",
    INT_01: "01",
    INT_02: "02",
    INT_03: "03",
    INT_04: "04",
    INT_05: "05",
    INT_06: "06",
    INT_07: "07",
    INT_08: "08",
    INT_09: "09",
    INT_10: "10",
    INT_11: "11",
    INT_12: "12",
    INT_13: "13",
    INT_14: "14",
    INT_15: "15",
    INT_16: "16",
    INT_17: "17",
    INT_18: "18",
    INT_19: "19",
    INT_20: "20",
    INT_21: "21",
    INT_22: "22",
    INT_23: "23",
    INT_24: "24",
    INT_25: "25",
    INT_26: "26",
    INT_27: "27",
    INT_28: "28",
    INT_29: "29",
    INT_30: "30",
    INT_31: "31",
    INT_32: "32",
    INT_33: "33",
    INT_34: "34",
    INT_35: "35",
    INT_36: "36",
    INT_37: "37",
    INT_38: "38",
    INT_39: "39",
    INT_40: "40",
    INT_41: "41",
    INT_42: "42",
    INT_43: "43",
    INT_44: "44",
    INT_45: "45",
    INT_46: "46",
    INT_47: "47",
    INT_48: "48",
    INT_49: "49",
    INT_50: "50",
    INT_51: "51",
    INT_52: "52",
    INT_53: "53",
    INT_54: "54",
    INT_55: "55",
    INT_56: "56",
    INT_57: "57",
    INT_58: "58",
    INT_59: "59",
    INT_60: "60",
    INT_61: "61",
    INT_62: "62",
    INT_63: "63",
    INT_64: "64",
    INT_65: "65",
    INT_66: "66",
    INT_67: "67",
    INT_68: "68",
    INT_69: "69",
    INT_70: "70",
    INT_71: "71",
    INT_72: "72",
    INT_73: "73",
    INT_74: "74",
    INT_75: "75",
    INT_76: "76",
    INT_77: "77",
    INT_78: "78",
    INT_79: "79",
    INT_80: "80",
    INT_81: "81",
    INT_82: "82",
    INT_83: "83",
    INT_84: "84",
    INT_85: "85",
    INT_86: "86",
    INT_87: "87",
    INT_88: "88",
    INT_89: "89",
    INT_90: "90",
    INT_91: "91",
    INT_92: "92",
    INT_93: "93",
    INT_94: "94",
    INT_95: "95",
    INT_96: "96",
    INT_97: "97",
    INT_98: "98",
    INT_99: "99",
    INT_0: "0",
    INT_1: "1",
    INT_2: "2",
    INT_3: "3",
    INT_4: "4",
    INT_5: "5",
    INT_6: "6",
    INT_7: "7",
    INT_8: "8",
    INT_9: "9",
    DIGIT: "[0-9]+",
    ONE: "one",
    FIRST: "first",
    TWO: "two",
    SECOND: "seconds?|secs?",
    THREE: "three",
    FOUR: "four",
    FIVE: "five",
    SIX: "six",
    SEVEN: "seven",
    EIGHT: "eight",
    NINE: "nine",
    TEN: "ten",
    TENTH: "tenth",
    ELEVEN: "eleven",
    ELEVENTH: "eleventh",
    TWELVE: "twelve",
    TWELFTH: "twelfth",
    THIRD: "third",
    THIRTEEN: "thirteen",
    THIRTEENTH: "thirteenth",
    FOURTH: "fourth",
    FOURTEEN: "fourteen",
    FOURTEENTH: "fourteenth",
    FIFTH: "fifth",
    FIFTEEN: "fifteen",
    FIFTEENTH: "fifteenth",
    SIXTH: "sixth",
    SIXTEEN: "sixteen",
    SIXTEENTH: "sixteenth",
    SEVENTH: "seventh",
    SEVENTEEN: "seventeen",
    SEVENTEENTH: "seventeenth",
    EIGHTH: "eighth",
    EIGHTEEN: "eightt?een",
    EIGHTEENTH: "eighteenth",
    NINTH: "ninth",
    NINETEEN: "nineteen",
    NINETEENTH: "nineteenth",
    TWENTY: "twenty",
    TWENTIETH: "twentieth",
    THIRTIETH: "thirtieth",
    THIRTY: "thirty",
    FARVARDIN: "far(vardin)?",
    ORDIBEHESHT: "ord(ibehesht)?",
    KHORDAD: "kho(rdad)?",
    TIR: "tir",
    AMORDAD: "amo(rdad)?|mor(dad)?",
    SHAHRIVAR: "sha(hrivar)?",
    MEHR: "mehr?",
    ABAN: "aban?",
    AZAR: "azar?",
    DEY: "dey",
    BAHMAN: "bah(man)?",
    ESFAND: "es[fp]{1}(and)?",
    SATURDAY: "sat(urday)?",
    SUNDAY: "sun(day)?",
    MONDAY: "mon(day)?",
    TUESDAY: "tue(sday)?",
    WEDNESDAY: "wed(nesday)?",
    THURSDAY: "thu(rsday)?",
    FRIDAY: "fri(day)?|weekend",
    THIS: "this",
    OF: "of",
    LAST: "last",
    NEXT: "next",
    NOW: "now",
    AGO: "ago",
    BEFORE: "before",
    START: "start",
    END: "end",
    PREVIOUS: "previous",
    SUFFIXES: "st|nd|rd|th",
    MICROSECOND: "microsecond|usec",
    MILLISECOND: "millisecond|msec|µsec|ms|µs",
    HOUR: "hours?",
    MINUTE: "minutes?|mins?",
    DAY: "days?",
    WEEKDAY: "weekdays?",
    WEEK: "weeks?",
    MONTH: "months?|mons?",
    YEAR: "years?",
    FORTNIGHT: "forth?night",
    TODAY: "today",
    TOMORROW: "tomorrow",
    TONIGHT: "tonight",
    YESTERDAY: "yesterday",
    AT: "@",
    BACK: "back",
    FRONT: "front",
    AM: "a" + SHDateLexer.DOT + "?m" + SHDateLexer.DOT + "?",
    PM: "p" + SHDateLexer.DOT + "?m" + SHDateLexer.DOT + "?",
    MIDNIGHT: "mid-?night",
    NOON: "noon|after-?noon",
    MORNING: "morning",
    EVENING: "evening|eve",
    NIGHT: "night",
    SIGN_TIME: "t",
    SIGN_WEEK: "w",
    UTC: "utc|gmt|z",
    EST: "est",
    EDT: "edt",
    CST: "cst",
    CDT: "cdt",
    MST: "mst",
    MDT: "mdt",
    PST: "pst",
    PDT: "pdt",
    INT_VIII: "viii",
    INT_VII: "vii",
    INT_VI: "vi",
    INT_V: "v",
    INT_XII: "xii",
    INT_XI: "xi",
    INT_X: "x",
    INT_IX: "ix",
    INT_IV: "iv",
    INT_III: "iii",
    INT_II: "ii",
    INT_I: "i",
    TZ: "[A-Za-z]{3,6}",
    DOT: `${SHDateLexer.DOT}`,
    UNKNOWN_CHAR: `[^ \t\\s${SHDateLexer.DOT}]`
};
class SHDateParser {
    constructor(srt) {
        this.data = {};
        this.Lexer = new SHDateLexer(srt);
        do {
            this.CompoundFormats() || this.DateFormats() || this.TimeFormats();
        } while (this.nextToken());
        return this.data;
    }
    CompoundFormats() {
        return this.standardsFormats() || this.compoundLocalizedNotations();
    }
    standardsFormats() {
        return this.dateTimeTZ() || this.dateWithAbbrTimeTZ();
    }
    dateTimeTZ() {
        if (this.dateWithDash(true) && this.time24Notation(true, true, true, true))
            return true;
        return false;
    }
    compoundLocalizedNotations() {
        return (this.CommonLogFormat() ||
            this.isoYearWeekDay() ||
            this.postgreSQL() ||
            this.unixTimestamp());
    }
    DateFormats() {
        return this.ISO8601Notations() || this.dateLocalizedNotations();
    }
    ISO8601Notations() {
        return (this.dateWithSlash(true) ||
            this.dateWithDash(true) ||
            this.dateWithDash(false) ||
            this.dateWithSlash(false) ||
            this.dateWithOut());
    }
    dateLocalizedNotations() {
        return (this.Date1Abbr(true) ||
            this.dayTextualMonthYear() ||
            this.year4TextualMonth() ||
            this.textualMonthYear4() ||
            this.textualMonthDayYear() ||
            this.dateyear4MandatoryPrefix() ||
            this.dateMonthTextual());
    }
    TimeFormats() {
        return (this.time24Notation(true, true, true, true) ||
            this.time12Notation(true, true, true, true));
    }
    CommonLogFormat() {
        const pos = this.getPosition();
        if (this.dateWithSlash(true) && this.time24Notation(true, true, true, true))
            return true;
        this.resetPosition(pos);
        return false;
    }
    isoYearWeekDay() {
        const pos = this.getPosition();
        const year = this.year4();
        if (year) {
            this.isTKDash();
            if (this.isTKSignWeek()) {
                const week = this.int10To53() || this.int00To09();
                if (week) {
                    this.data["YEAR"] = year;
                    this.data["WEEK_OF_YEAR"] = week;
                    this.isTKDash();
                    const dow = this.int0To7();
                    if (dow) {
                        this.data["DAY_OF_WEEK"] = dow;
                    }
                    return true;
                }
                throw new Error("week between 00 - 53 - ex 1402W01-5 || 1402W015");
            }
        }
        this.resetPosition(pos);
        return false;
    }
    postgreSQL() {
        const pos = this.getPosition();
        const year = this.year4();
        if (year && this.isTKDot()) {
            const doy = `${this.int10To36() || this.int00To09()}${this.int0To9()}`;
            if (doy) {
                this.data["YEAR"] = year;
                this.data["DAY_OF_YEAR"] = doy;
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    unixTimestamp() {
        const pos = this.getPosition();
        if (this.isTKAT()) {
            const [sign, num] = this.number();
            if (num) {
                if (typeof sign == "number")
                    this.data["SIGN_TIMESTAMP"] = sign;
                this.data["TIMESTAMP"] = num;
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    time12Notation(issign = false, issec = false, isfrac = false, ismeridian = false) {
        const pos = this.getPosition();
        if (issign)
            this.isTKSignTime();
        const h12 = this.H12();
        if (h12 && this.isTKColon()) {
            const min = this.minutes();
            if (min) {
                this.data["HOURS"] = h12;
                this.data["MINUTES"] = min;
                if (issec) {
                    this.isTKColon();
                    const sec = this.seconds();
                    if (sec) {
                        this.data["SECONDS"] = sec;
                        if (isfrac) {
                            const frac = this.fractionalSecond();
                            if (frac) {
                                this.data["FRACTION"] = frac;
                            }
                        }
                    }
                }
                if (ismeridian) {
                    this.isTKSpace();
                    this.meridian();
                }
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    time24Notation(issign = false, issec = true, isfrac = false, istz = true) {
        const pos = this.getPosition();
        if (issign)
            this.isTKSignTime();
        const h24 = this.H24();
        if (h24 && this.isTKColon()) {
            const min = this.minutes(false);
            if (min) {
                this.data["HOURS"] = h24;
                this.data["MINUTES"] = min;
                const pos2 = this.getPosition();
                if (issec) {
                    this.isTKColon();
                    const sec = this.seconds(false);
                    if (sec) {
                        this.data["SECONDS"] = sec;
                        if (isfrac) {
                            const frac = this.fractionalSecond();
                            if (frac) {
                                this.data["FRACTION"] = frac;
                            }
                        }
                    }
                }
                else
                    this.resetPosition(pos2);
                if (istz) {
                    this.isTKSpace();
                    this.TZCorrection() || this.timeZone();
                }
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    TZCorrection() {
        let isTZ = false;
        const name = this.nameToken();
        const setTZ = (name, time) => {
            this.data["TZ_NAME"] = name;
            this.data["TZ_TIME"] = time;
        };
        switch (name) {
            case "UTC":
                setTZ("GMT", 0);
                isTZ = true;
                this.nextToken();
                break;
            case "IRST":
                setTZ("IRST", 210 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            case "EDT":
                setTZ("EDT", 240 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            case "EST":
            case "CDT":
                setTZ(name, 300 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            case "CST":
            case "MDT":
                setTZ(name, 360 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            case "MST":
            case "PDT":
                setTZ(name, 420 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            case "PST":
                setTZ("PST", 480 * 60000);
                isTZ = true;
                this.nextToken();
                break;
            default:
                isTZ = this.timeZone();
                break;
        }
        let PLUS_DASH = false, time = 0, sign = 1;
        PLUS_DASH = false;
        if (this.isTKPlus()) {
            sign = 1;
            PLUS_DASH = true;
        }
        else if (this.isTKDash()) {
            sign = -1;
            PLUS_DASH = true;
        }
        if (PLUS_DASH) {
            const h12 = this.H12();
            if (h12) {
                time += h12 * 60;
                this.isTKColon();
                const min = this.minutes();
                if (min) {
                    time += min * 1;
                    setTZ(name, sign * time * 60 * 1000);
                    return true;
                }
            }
        }
        else if (isTZ)
            return true;
        return false;
    }
    timeZone() {
        if (this.isToken("TZ")) {
            this.data["TZ_NAME"] = this.valueToken();
            return true;
        }
        return false;
    }
    number(issign = false, count = false) {
        let int, num = "", isInt = false;
        const pos = this.getPosition();
        const sign = this.signNumber() || 1;
        while ((int = this.int00To99() || this.int0To9())) {
            num += int;
            isInt = true;
        }
        if (isInt) {
            return [sign, num];
        }
        this.resetPosition(pos);
        return false;
    }
    H12(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To12() || this.int01To09();
        return this.H12(true) || this.int1To9();
    }
    H24(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To24() || this.int00To09();
        return this.H24(true) || this.int0To9();
    }
    meridian() {
        if (this.isToken("AM")) {
            this.data["MERIDIAN"] = false;
            this.nextToken();
            return true;
        }
        else if (this.isToken("PM")) {
            this.nextToken();
            this.data["MERIDIAN"] = true;
            return true;
        }
        return false;
    }
    minutes(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To59() || this.int00To09();
        return this.minutes(true) || this.int0To9();
    }
    seconds(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To59() || this.int00To09();
        return this.seconds(true) || this.int0To9();
    }
    fractionalSecond() {
        if (this.isTKDot()) {
            let int, isFrac = false;
            while ((int = this.int00To99() || this.int0To9())) {
                this.data["FRACTION"] += int;
                isFrac = true;
            }
            return true && isFrac;
        }
        return false;
    }
    dateyear4MandatoryPrefix() {
        const pos = this.getPosition();
        const year = this.year4();
        if (year) {
            this.data["YEAR"] = year;
            return true;
        }
        this.resetPosition(pos);
        return false;
    }
    dateWithSlash(isday = false) {
        const pos = this.getPosition();
        const year = this.year4();
        if (year && this.isTKSlash()) {
            const month = this.month(true) || this.monthTextual();
            if (month) {
                this.data["YEAR"] = year;
                this.data["MONTH"] = month;
                const pos2 = this.getPosition();
                if (isday && this.isTKSlash()) {
                    const day = this.day(true);
                    if (day) {
                        this.data["DAY"] = day;
                    }
                    else
                        this.resetPosition(pos2);
                }
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    dateWithOut() {
        const pos = this.getPosition();
        const year = this.year4();
        if (year) {
            const month = this.month(true) || this.monthTextual();
            if (month) {
                const day = this.day(true);
                if (day) {
                    this.data["YEAR"] = year;
                    this.data["MONTH"] = month;
                    this.data["DAY"] = day;
                    return true;
                }
            }
        }
        this.resetPosition(pos);
        return false;
    }
    dateWithDash(isday = false) {
        let sign;
        const pos = this.getPosition();
        const year = this.year4();
        if (year && this.isTKDash()) {
            const month = this.month(true) || this.monthTextual();
            if (month) {
                this.data["YEAR"] = year;
                this.data["MONTH"] = month;
                const pos2 = this.getPosition();
                if (isday && this.isTKDash()) {
                    const day = this.day(true);
                    if (day)
                        this.data["DAY"] = day;
                    else
                        this.resetPosition(pos2);
                }
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    year4TextualMonth() {
        const pos = this.getPosition();
        const year = this.year4();
        if (year && (this.isTKSpace() || this.isTKDot())) {
            const month = this.monthTextual();
            if (month) {
                this.data["YEAR"] = year;
                this.data["MONTH"] = month;
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    Date1Abbr(isday = false) {
        const pos = this.getPosition();
        const year = this.year4();
        if (year && this.isTKDash()) {
            const month = this.monthTextual();
            if (month) {
                this.data["YEAR"] = year;
                this.data["MONTH"] = month;
                const pos2 = this.getPosition();
                if (isday && this.isTKDash()) {
                    const day = this.day(true);
                    if (day) {
                        this.data["DAY"] = day;
                        return true;
                    }
                }
                else
                    this.resetPosition(pos2);
            }
        }
        this.resetPosition(pos);
        return false;
    }
    dateWithAbbrTimeTZ(isdname = false) {
        const pos = this.getPosition();
        if (this.dayNeme()) {
            this.isTKComma();
            this.isTKSpace();
            this.isTKComma();
        }
        const day = this.day(true);
        if (day) {
            this.isTKDash() || this.isTKSpace();
            const month = this.monthTextual();
            if (month) {
                this.isTKDash() || this.isTKSpace();
                const year = this.year4() || this.year2(true);
                if (year &&
                    this.isTKSpace() &&
                    this.time24Notation(true, true, true, true)) {
                    this.data["YEAR"] = year;
                    this.data["MONTH"] = month;
                    this.data["DAY"] = day;
                    return true;
                }
            }
        }
        this.resetPosition(pos);
        return false;
    }
    year4() {
        const y1 = this.year2(true);
        const y2 = this.year2(true);
        if (y1 && y2)
            return y1 + y2;
        return false;
    }
    year2(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int00To99();
        return this.year2(true) || this.int0To9();
    }
    dayWithSuffix() {
        const int = this.day(true);
        if (int) {
            this.daySuffixTextual();
            return int;
        }
        return false;
    }
    day(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To31() || this.int00To09();
        return this.day(true) || this.int0To9();
    }
    daySuffixTextual() {
        if (this.isToken("SUFFIXES")) {
            this.data["SUFFIXES"] = this.valueToken();
            this.nextToken();
            return true;
        }
        return false;
    }
    dayTextualMonthYear() {
        let year, month, day, pos = this.getPosition();
        day = this.dayWithSuffix();
        if (day) {
            this.isTKSpace() || this.isTKDash();
            month = this.monthTextual();
            if (month) {
                this.data["DAY"] = day;
                this.data["MONTH"] = month;
                this.isTKSpace() || this.isTKDash();
                year = this.year4();
                if (year) {
                    this.data["YEAR"] = year;
                }
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    textualMonthYear4() {
        const pos = this.getPosition();
        const month = this.monthTextual();
        if (month) {
            this.isTKSpace() || this.isTKDash();
            const year = this.year4();
            if (year) {
                this.data["YEAR"] = year;
                this.data["MONTH"] = month;
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    textualMonthDayYear() {
        let year, month, day, pos = this.getPosition();
        month = this.monthTextual();
        if (month) {
            this.isTKSpace() || this.isTKDot() || this.isTKDash();
            day = this.dayWithSuffix();
            if (day) {
                this.daySuffixTextual();
                this.isTKSpace() || this.isTKComma() || this.isTKDot();
                year = this.year4();
                if (year) {
                    this.data["YEAR"] = year;
                }
                this.data["MONTH"] = month;
                this.data["DAY"] = day;
                return true;
            }
        }
        this.resetPosition(pos);
        return false;
    }
    dateMonthTextual() {
        const pos = this.getPosition();
        const month = this.monthTextual();
        if (month) {
            this.data["MONTH"] = month;
            return true;
        }
        this.resetPosition(pos);
        return false;
    }
    monthTextual() {
        switch (this.nameToken()) {
            case "FARVARDIN":
            case "INT_I":
                this.nextToken();
                return 1;
            case "ORDIBEHESHT":
            case "INT_II":
                this.nextToken();
                return 2;
            case "KHORDAD":
            case "INT_III":
                this.nextToken();
                return 3;
            case "TIR":
            case "INT_IV":
                this.nextToken();
                return 4;
            case "AMORDAD":
            case "INT_V":
                this.nextToken();
                return 5;
            case "SHAHRIVAR":
            case "INT_VI":
                this.nextToken();
                return 6;
            case "MEHR":
            case "INT_VII":
                this.nextToken();
                return 7;
            case "ABAN":
            case "INT_VIII":
                this.nextToken();
                return 8;
            case "AZAR":
            case "INT_IX":
                this.nextToken();
                return 9;
            case "DEY":
            case "INT_X":
                this.nextToken();
                return 10;
            case "BAHMAN":
            case "INT_XI":
                this.nextToken();
                return 11;
            case "ESFAND":
            case "INT_XII":
                this.nextToken();
                return 12;
            default:
                return false;
        }
    }
    month(isMandatoryPrefix = true) {
        if (isMandatoryPrefix)
            return this.int10To12() || this.int00To09();
        return this.month(true) || this.int0To9();
    }
    dayNeme() {
        switch (this.nameToken()) {
            case "SATURDAY":
                this.nextToken();
                return 0;
            case "SUNDAY":
                this.nextToken();
                return 1;
            case "MONDAY":
                this.nextToken();
                return 2;
            case "TUESDAY":
                this.nextToken();
                return 3;
            case "WEDNESDAY":
                this.nextToken();
                return 4;
            case "THURSDAY":
                this.nextToken();
                return 5;
            case "FRIDAY":
                this.nextToken();
                return 6;
            default:
                return false;
        }
    }
    daytext() {
        if (this.isToken("WEEKDAY")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    signNumber() {
        if (this.isTKPlus()) {
            this.nextToken();
            return 1;
        }
        else if (this.isTKDash()) {
            this.nextToken();
            return -1;
        }
        return false;
    }
    isToken(token) {
        if (this.Lexer.getLookahead() !== false)
            return this.Lexer.getLookahead().is(token);
    }
    nameToken() {
        if (this.Lexer.getLookahead() !== false) {
            return this.Lexer.getLookahead().getName();
        }
        return false;
    }
    valueToken() {
        return this.Lexer.getLookahead().getValue();
    }
    nextToken() {
        return this.Lexer.moveNext();
    }
    getPosition() {
        return this.Lexer.getPosition();
    }
    resetPosition(pos) {
        return this.Lexer.resetPosition(pos);
    }
    isTKColon() {
        if (this.isToken("COLON")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKDot() {
        if (this.isToken("DOT")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKDash() {
        if (this.isToken("DASH")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKPlus() {
        if (this.isToken("PLUS")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKComma() {
        if (this.isToken("COMMA")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKSpace() {
        if (this.isToken("SPACE")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKSpaceMore() {
        let space = false;
        while (this.isTKSpace()) {
            space = true;
        }
        if (space) {
            return true;
        }
        return false;
    }
    isTKSignTime() {
        if (this.isToken("SIGN_TIME")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKWeek() {
        if (this.isToken("WEEK")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKSlash() {
        if (this.isToken("SLASH")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKSignWeek() {
        if (this.isToken("SIGN_WEEK")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    isTKAT() {
        if (this.isToken("AT")) {
            this.nextToken();
            return true;
        }
        return false;
    }
    oneToThirtyOneTextual() {
        switch (this.nameToken()) {
            case "ONE":
                this.nextToken();
                return 1;
            case "TWO":
                this.nextToken();
                return 2;
            case "THREE":
                this.nextToken();
                return 3;
            case "FOUR":
                this.nextToken();
                return 4;
            case "FIVE":
                this.nextToken();
                return 5;
            case "SIX":
                this.nextToken();
                return 6;
            case "SEVEN":
                this.nextToken();
                return 7;
            case "EIGH":
                this.nextToken();
                return 8;
            case "NINE":
                this.nextToken();
                return 9;
            case "TEN":
                this.nextToken();
                return 10;
            case "ELEVEN":
                this.nextToken();
                return 11;
            case "TWELVE":
                this.nextToken();
                return 12;
            case "THIRTEEN":
                this.nextToken();
                return 13;
            case "FOURTEEN":
                this.nextToken();
                return 14;
            case "FIFTEEN":
                this.nextToken();
                return 15;
            case "SIXTEEN":
                this.nextToken();
                return 16;
            case "SEVENTEEN":
                this.nextToken();
                return 17;
            case "EIGHTEEN":
                this.nextToken();
                return 18;
            case "NINETEEN":
                this.nextToken();
                return 19;
            case "TWENTY":
                this.nextToken();
                this.isTKDash() || this.isTKSpace();
                switch (this.nameToken()) {
                    case "ONE":
                        this.nextToken();
                        return 21;
                    case "TWO":
                        this.nextToken();
                        return 22;
                    case "THREE":
                        this.nextToken();
                        return 23;
                    case "FOUR":
                        this.nextToken();
                        return 24;
                    case "FIVE":
                        this.nextToken();
                        return 25;
                    case "SIX":
                        this.nextToken();
                        return 26;
                    case "SEVEN":
                        this.nextToken();
                        return 27;
                    case "EIGH":
                        this.nextToken();
                        return 28;
                    case "NINE":
                        this.nextToken();
                        return 29;
                    default:
                        this.nextToken();
                        return 20;
                }
            case "THIRTY":
                this.isTKDash() || this.isTKSpace();
                if (this.isToken("ONE")) {
                    this.nextToken();
                    return 31;
                }
                this.nextToken();
                return 30;
            default:
                return false;
        }
    }
    firstToThirtyFirstTextual() {
        switch (this.nameToken()) {
            case "FIRST":
                this.nextToken();
                return 1;
            case "SECOND":
                this.nextToken();
                return 2;
            case "THIRD":
                this.nextToken();
                return 3;
            case "FOURTH":
                this.nextToken();
                return 4;
            case "FIFTH":
                this.nextToken();
                return 5;
            case "SIXTH":
                this.nextToken();
                return 6;
            case "SEVENTH":
                this.nextToken();
                return 7;
            case "EIGHTH":
                this.nextToken();
                return 8;
            case "NINTH":
                this.nextToken();
                return 9;
            case "TENTH":
                this.nextToken();
                return 10;
            case "ELEVENTH":
                this.nextToken();
                return 11;
            case "TWELFTH":
                this.nextToken();
                return 12;
            case "THIRTEENTH":
                this.nextToken();
                return 13;
            case "FOURTEENTH":
                this.nextToken();
                return 14;
            case "FIFTEENTH":
                this.nextToken();
                return 15;
            case "SIXTEENTH":
                this.nextToken();
                return 16;
            case "SEVENTEENTH":
                this.nextToken();
                return 17;
            case "EIGHTEENTH":
                this.nextToken();
                return 18;
            case "NINETEENTH":
                this.nextToken();
                return 19;
            case "TWENTIETH":
                this.nextToken();
                return 20;
            case "TWENTY": {
                this.nextToken();
                this.isTKDash() || this.isTKSpace();
                switch (this.nameToken()) {
                    case "FIRST":
                        this.nextToken();
                        return 21;
                    case "SECOND":
                        this.nextToken();
                        return 22;
                    case "THIRD":
                        this.nextToken();
                        return 23;
                    case "FOURTH":
                        this.nextToken();
                        return 24;
                    case "FIFTH":
                        this.nextToken();
                        return 25;
                    case "SIXTH":
                        this.nextToken();
                        return 26;
                    case "SEVENTH":
                        this.nextToken();
                        return 27;
                    case "EIGHTH":
                        this.nextToken();
                        return 28;
                    case "NINTH":
                        this.nextToken();
                        return 29;
                }
                break;
            }
            case "THIRTIETH":
                this.nextToken();
                return 30;
            case "THIRTY":
                this.isTKDash() || this.isTKSpace();
                if (this.isToken("FIRST")) {
                    this.nextToken();
                    return 31;
                }
                return false;
            default:
                return false;
        }
    }
    int00To99() {
        return this.int10To99() || this.int00To09();
    }
    int10To99() {
        switch (this.nameToken()) {
            case "INT_60":
            case "INT_61":
            case "INT_62":
            case "INT_63":
            case "INT_64":
            case "INT_65":
            case "INT_66":
            case "INT_67":
            case "INT_68":
            case "INT_69":
            case "INT_70":
            case "INT_71":
            case "INT_72":
            case "INT_73":
            case "INT_74":
            case "INT_75":
            case "INT_76":
            case "INT_77":
            case "INT_78":
            case "INT_79":
            case "INT_80":
            case "INT_81":
            case "INT_82":
            case "INT_83":
            case "INT_84":
            case "INT_85":
            case "INT_86":
            case "INT_87":
            case "INT_88":
            case "INT_89":
            case "INT_90":
            case "INT_91":
            case "INT_92":
            case "INT_93":
            case "INT_94":
            case "INT_95":
            case "INT_96":
            case "INT_97":
            case "INT_98":
            case "INT_99":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To59();
        }
    }
    int10To59() {
        switch (this.nameToken()) {
            case "INT_54":
            case "INT_55":
            case "INT_56":
            case "INT_57":
            case "INT_58":
            case "INT_59":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To53();
        }
    }
    int10To53() {
        switch (this.nameToken()) {
            case "INT_37":
            case "INT_38":
            case "INT_39":
            case "INT_40":
            case "INT_41":
            case "INT_42":
            case "INT_43":
            case "INT_44":
            case "INT_45":
            case "INT_46":
            case "INT_47":
            case "INT_48":
            case "INT_49":
            case "INT_50":
            case "INT_51":
            case "INT_52":
            case "INT_53":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To36();
        }
    }
    int10To36() {
        switch (this.nameToken()) {
            case "INT_32":
            case "INT_33":
            case "INT_34":
            case "INT_35":
            case "INT_36":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To31();
        }
    }
    int10To31() {
        switch (this.nameToken()) {
            case "INT_25":
            case "INT_26":
            case "INT_27":
            case "INT_28":
            case "INT_29":
            case "INT_30":
            case "INT_31":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To24();
        }
    }
    int10To24() {
        if (this.isToken("INT_24")) {
            const int = this.valueToken();
            this.nextToken();
            return int;
        }
        return this.int10To23();
    }
    int10To23() {
        switch (this.nameToken()) {
            case "INT_13":
            case "INT_14":
            case "INT_15":
            case "INT_16":
            case "INT_17":
            case "INT_18":
            case "INT_19":
            case "INT_20":
            case "INT_21":
            case "INT_22":
            case "INT_23":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int10To12();
        }
    }
    int10To12() {
        switch (this.nameToken()) {
            case "INT_10":
            case "INT_11":
            case "INT_12":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return false;
        }
    }
    int00To09() {
        return this.int01To09() || this.int00();
    }
    int01To09() {
        switch (this.nameToken()) {
            case "INT_01":
            case "INT_02":
            case "INT_03":
            case "INT_04":
            case "INT_05":
            case "INT_06":
            case "INT_07":
            case "INT_08":
            case "INT_09":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return false;
        }
    }
    int0To9() {
        return this.int1To9() || this.int0();
    }
    int1To9() {
        switch (this.nameToken()) {
            case "INT_8":
            case "INT_9":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return this.int1To7();
        }
    }
    int0To7() {
        return this.int1To7() || this.int0();
    }
    int1To7() {
        switch (this.nameToken()) {
            case "INT_1":
            case "INT_2":
            case "INT_3":
            case "INT_4":
            case "INT_5":
            case "INT_6":
            case "INT_7":
                const int = this.valueToken();
                this.nextToken();
                return int;
            default:
                return false;
        }
    }
    int00() {
        if (this.isToken("INT_00")) {
            const int = this.valueToken();
            this.nextToken();
            return int;
        }
        return false;
    }
    int0() {
        if (this.isToken("INT_0")) {
            const int = this.valueToken();
            this.nextToken();
            return int;
        }
        return false;
    }
}
class SHDateToken {
    constructor(name, value, offset, position, length) {
        this.name = name;
        this.value = value;
        this.offset = offset;
        this.position = position;
        this.length = length;
    }
    getPosition() {
        return this.position;
    }
    getOffset() {
        return this.offset;
    }
    getName() {
        return this.name;
    }
    getValue() {
        return this.value;
    }
    getLength() {
        return this.length;
    }
    is(token) {
        if (typeof token === "string") {
            return this.name === token;
        }
        else if (token instanceof SHDateToken) {
            return this.name === token.getName();
        }
    }
    remove() {
        this.name = undefined;
        this.value = undefined;
        this.offset = undefined;
        this.position = undefined;
        this.length = undefined;
    }
}
class SHDate {
    constructor(mix = false, ...args) {
        _SHDate_instances.add(this);
        _SHDate_date.set(this, new Date());
        _SHDate_sh.set(this, {});
        _SHDate_config.set(this, {
            time_zone: "Asia/Tehran",
            word_language: SHDateWord.LANGUAGE,
            first_day_of_week: SHDateWord.FIRST_DAY_OF_WEEK,
            time_difference_server: 0
        });
        if (!(new.target || this)) {
            return new _a(...arguments);
        }
        if (typeof mix == "number")
            if (mix >= 1200 &&
                mix <= 1700 &&
                args[0] >= 0 &&
                args[0] <= 11) {
                const [month = 0, date = 1, hours = 0, minute = 0, second = 0, millisecond = 0] = args;
                this.setFullYear(mix, month, date);
                this.setHours(hours, minute, second, millisecond);
            }
            else
                this.setTime(mix);
        else if (typeof mix == "string") {
            const [time = this.getTime()] = args;
            this.setTime(_a.parse(mix, time));
        }
        else if (mix instanceof _a || mix instanceof Date)
            this.setTime(mix.getTime());
        else if (typeof mix == "boolean")
            this.setTime(__classPrivateFieldGet(this, _SHDate_date, "f").getTime());
        return this;
    }
    isLeapYear(year = this.getFullYear()) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year) === 1;
    }
    dayOfWeek(year, month, date, FDOW = __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, month, date, FDOW);
    }
    nthWeekdayOfMonth(year, month, day) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_nthWeekdayOfMonth).call(this, year, month, day);
    }
    getNthWeekdayOfMonth(day, nth = false) {
        const dates = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_nthWeekdayOfMonth).call(this, this.getFullYear(), this.getMonth(), day);
        if (nth == false)
            return dates;
        else if (day < 0 ||
            day > 6 ||
            nth < 1 ||
            nth > dates.length)
            return false;
        return dates[nth - 1];
    }
    getFirstWeekdayOfMonth(day) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_nthWeekdayOfMonth).call(this, this.getFullYear(), this.getMonth(), day)[0];
    }
    getLastWeekdayOfMonth(day) {
        const dates = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_nthWeekdayOfMonth).call(this, this.getFullYear(), this.getMonth(), day);
        return dates[dates.length - 1];
    }
    weekdayInMonth(year, month, date) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_WeekdayInMonth).call(this, year, month, date);
    }
    getWeekdayInMonth() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_WeekdayInMonth).call(this, this.getFullYear(), this.getMonth(), this.getDate());
    }
    dayOfYear(month, date) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, date);
    }
    getDayOfYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, this.getMonth(), this.getDate());
    }
    getUTCDayOfYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, this.getUTCMonth(), this.getUTCDate());
    }
    weekOfYear(year, month, date, FDOW = __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, year, month, date, FDOW);
    }
    getWeekOfYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, this.getFullYear(), this.getMonth(), this.getDate());
    }
    getUTCWeekOfYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate());
    }
    weeksInYear(year) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, year);
    }
    getWeeksInYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, this.getFullYear());
    }
    getUTCWeeksInYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, this.getUTCFullYear());
    }
    weekOfDay(year, week, date = 0) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfDay).call(this, year, week, date);
    }
    setWeek(year, week, date = 0) {
        const [years, months, days] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfDay).call(this, year, week, date);
        return this.setFullYear(years, months, days);
    }
    dateOfDayOfYear(year, doy) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, year, doy);
    }
    setDayOfYear(year, doy) {
        const [years, months, days] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, year, doy);
        return this.setFullYear(years, months, days);
    }
    setUTCDayOfYear(year, doy) {
        const [years, months, days] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, year, doy);
        return this.setUTCFullYear(years, months, days);
    }
    daysInMonth(year, month) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, month);
    }
    getDaysInMonth() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, this.getFullYear(), this.getMonth());
    }
    getUTCDaysInMonth() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, this.getUTCFullYear(), this.getUTCMonth());
    }
    daysInYear(year) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year);
    }
    getDaysInYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, this.getFullYear());
    }
    getUTCDaysInYear() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, this.getUTCFullYear());
    }
    timeCorrection(hours, minute, second, millisecond = 0) {
        let time, doy;
        time = hours * 3600000 + minute * 60000 + second * 1000 + millisecond;
        millisecond = time % 1000;
        second = Math.trunc(time / 1000) % 60;
        minute = Math.trunc(time / 60000) % 60;
        hours = Math.trunc(time / 3600000) % 24;
        doy = Math.trunc(time / 86400000);
        return [hours, minute, second, millisecond, doy];
    }
    dateCorrection(year, month = 0, day = 1) {
        month++;
        if (month < 1)
            do {
                year--;
                month += 12;
            } while (month < 1);
        else if (month > 12)
            do {
                year++;
                month -= 12;
            } while (month > 12);
        month--;
        const doy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, day);
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, year, doy);
    }
    weekCorrection(year, week, day = 0) {
        const [y4, month, date] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfDay).call(this, year, week, day);
        const [iy, iw] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, y4, month, date);
        const dow = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, y4, month, date);
        return [iy, iw, dow];
    }
    checkDate(year, month, date) {
        return !(year < 1 ||
            year > 3500000 ||
            month < 0 ||
            month > 11 ||
            date < 1 ||
            date > __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, month));
    }
    static checkDate(year, month, date) {
        return new _a().checkDate(year, month, date);
    }
    static checkTime(hours, minutes, seconds, milliseconds = 0) {
        return !(hours < 0 ||
            hours > 23 ||
            minutes < 0 ||
            minutes > 59 ||
            seconds < 0 ||
            seconds > 59 ||
            milliseconds < 0 ||
            milliseconds > 999);
    }
    checkTime(hours, minutes, seconds, milliseconds = 0) {
        return _a.checkTime(hours, minutes, seconds, milliseconds);
    }
    static checkTime12(hours, minutes, seconds, milliseconds = 0) {
        return !(hours < 1 ||
            hours > 12 ||
            minutes < 0 ||
            minutes > 59 ||
            seconds < 0 ||
            seconds > 59 ||
            milliseconds < 0 ||
            milliseconds > 999);
    }
    checkTime12(hours, minutes, seconds, milliseconds = 0) {
        return _a.checkTime12(hours, minutes, seconds, milliseconds);
    }
    checkWeek(year, week, day) {
        return !(year < 1 ||
            year > 10000 ||
            week < 1 ||
            week > __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, year) ||
            day < 0 ||
            day > 7);
    }
    static checkWeek(year, week, day) {
        return new _a().checkWeek(year, week, day);
    }
    getDates(time = this.getTime()) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_getDates).call(this, time, false);
    }
    getUTCDates(time = this.getTime()) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_getDates).call(this, time, true);
    }
    format(format, isUTC = false) {
        const year = isUTC ? this.getUTCFullYear() : this.getFullYear(), month = isUTC ? this.getUTCMonth() : this.getMonth(), date = isUTC ? this.getUTCDate() : this.getDate(), hours = isUTC ? this.getUTCHours() : this.getHours(), minute = isUTC ? this.getUTCMinutes() : this.getMinutes(), second = isUTC ? this.getUTCSeconds() : this.getSeconds(), millisecond = isUTC
            ? this.getUTCMilliseconds()
            : this.getMilliseconds(), weekday = isUTC ? this.getUTCDay() : this.getDay();
        var str = [];
        format.split(/\s*(?:=|$)\s*/).forEach((f) => {
            switch (f) {
                case "YY":
                    str.push(`${year}`.padStart(4, "0"));
                    break;
                case "yy":
                    str.push(year);
                    break;
                case "MM":
                    str.push(`${month}`.padStart(2, "0"));
                    break;
                case "mm":
                    str.push(month);
                    break;
                case "DD":
                    str.push(`${date}`.padStart(2, "0"));
                    break;
                case "dd":
                    str.push(date);
                    break;
                case "HH":
                    str.push(`${hours}`.padStart(2, "0"));
                    break;
                case "hh":
                    str.push(hours);
                    break;
                case "II":
                    str.push(`${minute}`.padStart(2, "0"));
                    break;
                case "ii":
                    str.push(minute);
                    break;
                case "SS":
                    str.push(`${second}`.padStart(2, "0"));
                    break;
                case "ss":
                    str.push(second);
                    break;
                case "MS":
                    str.push(`${millisecond}`.padStart(3, "0"));
                    break;
                case "ms":
                    str.push(millisecond);
                    break;
                case "Diy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year).toString().padStart(3, "0"));
                    break;
                case "diy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year));
                    break;
                case "Doy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, date).toString().padStart(3, "0"));
                    break;
                case "doy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, date));
                    break;
                case "Dim":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, month).toString().padStart(2, "0"));
                    break;
                case "dim":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, month));
                    break;
                case "Dow":
                    str.push(`${weekday}`.padStart(2, "0"));
                    break;
                case "dow":
                    str.push(weekday);
                    break;
                case "Wiy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, year).toString().padStart(2, "0"));
                    break;
                case "wiy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weeksInYear).call(this, year));
                    break;
                case "Woy":
                    const [iso_year, iso_week] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, year, month, date);
                    str.push([
                        `${iso_year}`.padStart(4, "0"),
                        `${iso_week}`.padStart(2, "0")
                    ]);
                    break;
                case "woy":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, year, month, date));
                    break;
                case "dsn":
                    str.push(SHDateWord.getDayShortNames(weekday, __classPrivateFieldGet(this, _SHDate_config, "f").word_language, __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week));
                    break;
                case "dfn":
                    str.push(SHDateWord.getDayFullNames(weekday, __classPrivateFieldGet(this, _SHDate_config, "f").word_language, __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week));
                    break;
                case "efn":
                    str.push(SHDateWord.getMeridienFullNames(hours, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "esn":
                    str.push(SHDateWord.getMeridienShortNames(hours, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "mfn":
                    str.push(SHDateWord.getMonthFullNames(month, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "msn":
                    str.push(SHDateWord.getMonthShortNames(month, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "asn":
                    str.push(SHDateWord.getAnimalsFullNames(year, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "csn":
                    str.push(SHDateWord.getConstellationsFullNames(month, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "ssn":
                    str.push(SHDateWord.getSeasonFullNames(month, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "osn":
                    str.push(SHDateWord.getSolsticeFullNames(month, date, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "sun":
                    str.push(SHDateWord.getSuffixNames(date, __classPrivateFieldGet(this, _SHDate_config, "f").word_language));
                    break;
                case "LPS":
                case "lps":
                    str.push(__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year, true));
                    break;
                default:
                    str.push(f);
                    break;
            }
        });
        return str;
    }
    static now() {
        return Date.now();
    }
    static UTC(...args) {
        var date = new Date(new _a(args).getTime());
        return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    }
    setFullYear(year, month = false, date = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setFullYear).call(this, year, month, date, false);
    }
    setUTCFullYear(year, month = false, date = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setFullYear).call(this, year, month, date, true);
    }
    setMonth(month, date = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMonth).call(this, month, date, false);
    }
    setUTCMonth(month, date = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMonth).call(this, month, date, true);
    }
    setDate(date) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setDate).call(this, date, false);
    }
    setUTCDate(date) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setDate).call(this, date, true);
    }
    setHours(hours, minutes = false, seconds = false, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setHours).call(this, hours, minutes, seconds, milliseconds, false);
    }
    setUTCHours(hours, minutes = false, seconds = false, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setHours).call(this, hours, minutes, seconds, milliseconds, true);
    }
    setMinutes(minutes, seconds = false, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMinutes).call(this, minutes, seconds, milliseconds, false);
    }
    setUTCMinutes(minutes, seconds = false, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMinutes).call(this, minutes, seconds, milliseconds, true);
    }
    setSeconds(seconds, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setSeconds).call(this, seconds, milliseconds, false);
    }
    setUTCSeconds(seconds, milliseconds = false) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setSeconds).call(this, seconds, milliseconds, true);
    }
    setMilliseconds(milliseconds) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMilliseconds).call(this, milliseconds, false);
    }
    setUTCMilliseconds(milliseconds) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_setMilliseconds).call(this, milliseconds, true);
    }
    getFullYear() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").year;
    }
    getUTCFullYear() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_year;
    }
    getMonth() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").month;
    }
    getUTCMonth() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_month;
    }
    getDate() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").date;
    }
    getUTCDate() {
        return __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_date;
    }
    getHours() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getHours();
    }
    getUTCHours() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getUTCHours();
    }
    getMinutes() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getMinutes();
    }
    getUTCMinutes() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getUTCMinutes();
    }
    getSeconds() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getSeconds();
    }
    getUTCSeconds() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getUTCSeconds();
    }
    getMilliseconds() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getMilliseconds();
    }
    getUTCMilliseconds() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getUTCMilliseconds();
    }
    getDay() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, this.getFullYear(), this.getMonth(), this.getDate());
    }
    getUTCDay() {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate());
    }
    getTimezoneOffset() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getTimezoneOffset();
    }
    setTime(time) {
        __classPrivateFieldGet(this, _SHDate_date, "f").setTime(time + __classPrivateFieldGet(this, _SHDate_config, "f").time_difference_server);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateSync).call(this);
        return this.getTime();
    }
    getTime() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getTime();
    }
    getUTCTime() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").getTime() + this.getTimezoneOffset() * 60000;
    }
    valueOf() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").valueOf();
    }
    toString() {
        return `${this.toDateString()} ${this.toTimeString()}`;
    }
    toUTCString() {
        return `${this.toUTCDateString()} ${this.toUTCTimeString()}`;
    }
    toDateString() {
        const [day_short_name, date, month_short_name, year] = this.format("dsn=DD=msn=YY");
        return `${day_short_name} ${date} ${month_short_name} ${year}`;
    }
    toUTCDateString() {
        const [day_short_name, date, month_short_name, year] = this.format("dsn=DD=msn=YY", true);
        return `${day_short_name}, ${date} ${month_short_name} ${year}`;
    }
    toTimeString() {
        return __classPrivateFieldGet(this, _SHDate_date, "f").toTimeString();
    }
    toUTCTimeString() {
        const [hours, minute, second] = this.format("HH=II=SS", true);
        return `${hours}:${minute}:${second} GMT`;
    }
    toISOString() {
        const [dates, times] = __classPrivateFieldGet(this, _SHDate_date, "f").toJSON().split(/\s*(?:T|$)\s*/);
        const [year, month, date] = this.format("YY=MM=DD");
        return `${year}-${month}-${date}T${times}`;
    }
    toJSON() {
        return this.toISOString();
    }
    static parse(str, time = _a.now()) {
        let date = new _a(time), defaultDate = date.getDates(), now = 0, year = 0, month = 0, day = 1, hours = 0, minutes = 0, seconds = 0, milliseconds = 0, doy, dow, week, tz = "", tztime = 0;
        const dataObj = new SHDateParser(str);
        Object.entries(dataObj).forEach(([key, value]) => {
            switch (key) {
                case "YEAR":
                    year = Math.trunc(value);
                    break;
                case "MONTH":
                    month = Math.trunc(value) - 1;
                    break;
                case "DAY":
                    day = Math.trunc(value);
                    break;
                case "HOURS":
                    hours = Math.trunc(value);
                    break;
                case "MINUTES":
                    minutes = Math.trunc(value);
                    break;
                case "SECONDS":
                    seconds = Math.trunc(value);
                    break;
                case "FRACTION":
                    milliseconds = Math.trunc(value);
                    break;
                case "TZ":
                    tz = value;
                    break;
                case "TZ_TIME":
                    tztime = date.getTimezoneOffset() * -1 * 60000 - value;
                    break;
                case "TIMESTAMP":
                    date.setTime(Math.trunc(value));
                    break;
                case "DAY_OF_YEAR":
                    doy = Math.trunc(value);
                    date.setDayOfYear(year, doy);
                    year = date.getFullYear();
                    month = date.getMonth();
                    day = date.getDate();
                    break;
                case "WEEK_OF_YEAR":
                    week = Math.trunc(value);
                    dow = dataObj.DAY_OF_WEEK ? Math.trunc(dataObj.DAY_OF_WEEK) - 1 : 0;
                    date.setWeek(year, week, dow);
                    year = date.getFullYear();
                    month = date.getMonth();
                    day = date.getDate();
                    break;
                case "NOW":
                    now = _a.now();
                    date.setTime(now);
                    break;
                case "TODAY_MIDNIGHT":
                    [hours, minutes, seconds, milliseconds] = date.restTime(0, 0, 0, 0);
                    break;
                case "NOON":
                    [hours, minutes, seconds, milliseconds] = date.restTime(12);
                    break;
                case "YESTERDAY":
                    day = date.getDate() - 1;
                    [hours, minutes, seconds, milliseconds] = date.restTime(0, 0, 0, 0);
                    break;
                case "TOMORROW":
                    day = date.getDate() + 1;
                    [hours, minutes, seconds, milliseconds] = date.restTime(0, 0, 0, 0);
                    break;
            }
        });
        year = year ? year : defaultDate.year;
        __classPrivateFieldGet(date, _SHDate_instances, "m", _SHDate_setHours).call(date, hours, minutes, seconds, milliseconds);
        __classPrivateFieldGet(date, _SHDate_instances, "m", _SHDate_setFullYear).call(date, year, month, day);
        date.setTime(date.getTime() + tztime);
        return date.getTime();
    }
    [(_SHDate_date = new WeakMap(), _SHDate_sh = new WeakMap(), _SHDate_config = new WeakMap(), _SHDate_instances = new WeakSet(), _SHDate_dateSync = function _SHDate_dateSync() {
        const _year = __classPrivateFieldGet(this, _SHDate_date, "f").getFullYear(), _month = __classPrivateFieldGet(this, _SHDate_date, "f").getMonth(), _date = __classPrivateFieldGet(this, _SHDate_date, "f").getDate(), _utc_year = __classPrivateFieldGet(this, _SHDate_date, "f").getUTCFullYear(), _utc_month = __classPrivateFieldGet(this, _SHDate_date, "f").getUTCMonth(), _utc_date = __classPrivateFieldGet(this, _SHDate_date, "f").getUTCDate();
        if (_utc_year == _year && _utc_month == _month && _utc_date == _date) {
            const [year, month, date] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GregorianToSolar).call(this, _year, _month, _date);
            __classPrivateFieldGet(this, _SHDate_sh, "f").year = __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_year = year;
            __classPrivateFieldGet(this, _SHDate_sh, "f").month = __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_month = month;
            __classPrivateFieldGet(this, _SHDate_sh, "f").date = __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_date = date;
        }
        else {
            [__classPrivateFieldGet(this, _SHDate_sh, "f").UTC_year, __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_month, __classPrivateFieldGet(this, _SHDate_sh, "f").UTC_date] =
                __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GregorianToSolar).call(this, _utc_year, _utc_month, _utc_date);
            [__classPrivateFieldGet(this, _SHDate_sh, "f").year, __classPrivateFieldGet(this, _SHDate_sh, "f").month, __classPrivateFieldGet(this, _SHDate_sh, "f").date] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GregorianToSolar).call(this, __classPrivateFieldGet(this, _SHDate_date, "f").getFullYear(), __classPrivateFieldGet(this, _SHDate_date, "f").getMonth(), __classPrivateFieldGet(this, _SHDate_date, "f").getDate());
        }
        return;
    }, _SHDate_timeSync = function _SHDate_timeSync() {
        __classPrivateFieldGet(this, _SHDate_date, "f").setTime(__classPrivateFieldGet(this, _SHDate_date, "f").getTime() + __classPrivateFieldGet(this, _SHDate_config, "f").time_difference_server);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateSync).call(this);
        return;
    }, _SHDate_GregorianToSolar = function _SHDate_GregorianToSolar(gyear, gmonth, gdate, is_julian = false) {
        var gdoy = (gyear - 1) * 365 + __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDayOfYear).call(this, gmonth, gdate) - 226745;
        if (__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GIsLeapYear).call(this, gyear) && gmonth > 1)
            gdoy++;
        const syear = Math.trunc(gdoy / 365) + 1;
        const sdoy = (gdoy % 365) +
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GIsLeapYear).call(this, gyear, true) -
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, syear, true);
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, syear, sdoy - 1);
    }, _SHDate_SolarToGregorian = function _SHDate_SolarToGregorian(s_year, s_month, s_date, is_julian = false) {
        const [syear, smonth, sdate] = s_month < 0 || s_month > 11
            ? this.dateCorrection(s_year, s_month, s_date)
            : [s_year, s_month, s_date];
        const sdoy = (syear - 1) * 365 +
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, smonth, sdate) +
            226746;
        const gyear = Math.trunc(sdoy / 365) + 1;
        const gdoy = (sdoy % 365) +
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, syear, true) -
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GIsLeapYear).call(this, gyear, true);
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDateOfDayOfYear).call(this, gyear, gdoy);
    }, _SHDate_GDayOfYear = function _SHDate_GDayOfYear(gmonth, gdate) {
        return ([0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334][gmonth] + gdate);
    }, _SHDate_GDateOfDayOfYear = function _SHDate_GDateOfDayOfYear(gyear, gdoy) {
        var gdiy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDaysInYear).call(this, gyear), data = { gmonth: 0, gdate: 0 };
        if (gdoy < 1)
            do {
                --gyear;
                gdiy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDaysInYear).call(this, gyear);
                gdoy += gdiy;
            } while (gdoy < 1);
        else if (gdoy > gdiy)
            do {
                ++gyear;
                gdiy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDaysInYear).call(this, gyear);
                gdoy -= gdiy;
            } while (gdoy > gdiy);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GDaysInMonths).call(this, gyear).every((gdim, gmoy) => {
            if (gdoy <= gdim)
                return false;
            gdoy -= gdim;
            data.gmonth = gmoy;
            data.gdate = Math.trunc(gdoy);
            return true;
        });
        return [gyear, data.gmonth, data.gdate];
    }, _SHDate_GDaysInMonths = function _SHDate_GDaysInMonths(year) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GIsLeapYear).call(this, year)
            ? [0, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
            : [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    }, _SHDate_GDaysInYear = function _SHDate_GDaysInYear(year) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_GIsLeapYear).call(this, year) ? 366 : 365;
    }, _SHDate_GIsLeapYear = function _SHDate_GIsLeapYear(year, all = false) {
        if (all)
            return (Math.ceil(Math.trunc(--year / 4) -
                Math.trunc(year / 100) +
                Math.trunc(year / 400)) - 150);
        return year % 4 == 0 && !(year % 100 == 0 && year % 400 != 0) ? 1 : 0;
    }, _SHDate_isLeapYear = function _SHDate_isLeapYear(year, all = false) {
        year = year + 1127;
        if (all)
            return Math.trunc(Math.ceil(year * 0.2422)) - 274;
        return Math.trunc((year + 1) * 0.2422) - Math.trunc(year * 0.2422);
    }, _SHDate_dayOfWeek = function _SHDate_dayOfWeek(year, month, date, FDOW = __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week) {
        return ((5 +
            year +
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year, true) +
            __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, date) -
            FDOW) %
            7);
    }, _SHDate_nthWeekdayOfMonth = function _SHDate_nthWeekdayOfMonth(year, month, day) {
        const first_dow = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, month, 1), first_nth = ((7 - first_dow + day) % 7) + 1;
        let nth = [first_nth, first_nth + 7, first_nth + 14, first_nth + 21];
        if (first_nth + 28 <= __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, month))
            nth.push(first_nth + 28);
        return nth;
    }, _SHDate_WeekdayInMonth = function _SHDate_WeekdayInMonth(year, month, date) {
        return (__classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_nthWeekdayOfMonth).call(this, this.getFullYear(), this.getMonth(), __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, month, date)).findIndex((item) => item == date) + 1);
    }, _SHDate_dayOfYear = function _SHDate_dayOfYear(month, date) {
        return _a.DAY_OF_YEAR[month] + date - 1;
    }, _SHDate_weekOfYear = function _SHDate_weekOfYear(year, month, date, FDOW = __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week) {
        let iw, iy;
        const doy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, month, date) + 1, far1weekday = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, 0, 1, FDOW) + 1;
        if (doy <= 8 - far1weekday && far1weekday > 4) {
            iy = --year;
            iw =
                far1weekday == 5 || (far1weekday == 6 && __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, iy))
                    ? 53
                    : 52;
            return [iy, iw];
        }
        const esf29weekday = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, 11, __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInMonth).call(this, year, 11), FDOW) + 1;
        if (doy > __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year) - esf29weekday && esf29weekday < 4) {
            iy = ++year;
            iw = 1;
            return [iy, iw];
        }
        iy = year;
        iw = (5 + doy + far1weekday - __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, month, date, FDOW)) / 7;
        if (far1weekday > 4)
            iw--;
        return [iy, iw];
    }, _SHDate_weeksInYear = function _SHDate_weeksInYear(year) {
        const far1dow = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, 0, 1) + 1;
        if (far1dow == 4 || (far1dow == 3 && __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year)))
            return 53;
        return 52;
    }, _SHDate_weekOfDay = function _SHDate_weekOfDay(year, week, date = 0) {
        const doy = (week - 1) * 7 + date + 1 - __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfWeek).call(this, year, 0, 4) + 2;
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateOfDayOfYear).call(this, year, doy);
    }, _SHDate_dateOfDayOfYear = function _SHDate_dateOfDayOfYear(year, doy) {
        var diy, month, date;
        doy++;
        diy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year);
        if (doy < 1)
            do {
                year--;
                doy += __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year);
            } while (doy < 1);
        else if (doy > diy)
            do {
                doy -= diy;
                year++;
                diy = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_daysInYear).call(this, year);
            } while (doy > diy);
        if (doy < 187) {
            month = Math.trunc((doy - 1) / 31);
            date = doy % 31 || 31;
        }
        else {
            doy -= 186;
            month = Math.trunc((doy - 1) / 30) + 6;
            date = doy % 30 || 30;
        }
        return [year, month, date];
    }, _SHDate_daysInMonth = function _SHDate_daysInMonth(year, month) {
        if (month < 11)
            return _a.DAYS_IN_MONTH[month];
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year) ? 30 : 29;
    }, _SHDate_daysInYear = function _SHDate_daysInYear(year) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isLeapYear).call(this, year) ? 366 : 365;
    }, _SHDate_getDates = function _SHDate_getDates(timestamp = this.getTime(), isUTC = false) {
        let date;
        if (typeof timestamp === "undefined")
            date = new _a();
        else if (timestamp instanceof _a)
            date = timestamp;
        else
            date = new _a(timestamp);
        return {
            milliseconds: isUTC ? date.getUTCMilliseconds() : date.getMilliseconds(),
            seconds: isUTC ? date.getUTCSeconds() : date.getSeconds(),
            minutes: isUTC ? date.getUTCMinutes() : date.getMinutes(),
            hours: isUTC ? date.getUTCHours() : date.getHours(),
            date: isUTC ? date.getUTCDate() : date.getDate(),
            day: isUTC ? date.getUTCDay() : date.getDay(),
            month: isUTC ? date.getUTCMonth() : date.getMonth(),
            year: isUTC ? date.getUTCFullYear() : date.getFullYear(),
            doy: __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dayOfYear).call(this, isUTC ? date.getUTCMonth() : date.getMonth(), isUTC ? date.getUTCDate() : date.getDate()),
            woy: __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_weekOfYear).call(this, isUTC ? date.getUTCFullYear() : date.getFullYear(), isUTC ? date.getUTCMonth() : date.getMonth(), isUTC ? date.getUTCDate() : date.getDate()),
            timestamp: isUTC ? date.getTime() : date.getUTCTime()
        };
    }, _SHDate_setFullYear = function _SHDate_setFullYear(year, month = false, date = false, isUTC = false) {
        month = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, month, isUTC ? this.getUTCMonth() : this.getMonth());
        date = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, date, isUTC ? this.getUTCDate() : this.getDate());
        const [gyear, gmonth, gdate] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_SolarToGregorian).call(this, year, month, date);
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCFullYear(gyear, gmonth, gdate)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setFullYear(gyear, gmonth, gdate);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateSync).call(this);
        return this.getTime();
    }, _SHDate_setMonth = function _SHDate_setMonth(month, date = false, isUTC = false) {
        date = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, date, isUTC ? this.getUTCDate() : this.getDate());
        const [gyear, gmonth, gdate] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_SolarToGregorian).call(this, this.getFullYear(), month, date);
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCFullYear(gyear, gmonth, gdate)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setFullYear(gyear, gmonth, gdate);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateSync).call(this);
        return this.getTime();
    }, _SHDate_setDate = function _SHDate_setDate(date, isUTC = false) {
        const [gyear, gmonth, gdate] = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_SolarToGregorian).call(this, this.getFullYear(), this.getMonth(), date);
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCFullYear(gyear, gmonth, gdate)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setFullYear(gyear, gmonth, gdate);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_dateSync).call(this);
        return this.getTime();
    }, _SHDate_setHours = function _SHDate_setHours(hours, minutes = false, seconds = false, milliseconds = false, isUTC = false) {
        milliseconds = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, milliseconds, isUTC ? this.getUTCMilliseconds() : this.getMilliseconds());
        seconds = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, seconds, isUTC ? this.getUTCSeconds() : this.getSeconds());
        minutes = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, minutes, isUTC ? this.getUTCMinutes() : this.getMinutes());
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCHours(hours, minutes, seconds, milliseconds)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setHours(hours, minutes, seconds, milliseconds);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_timeSync).call(this);
        return this.getTime();
    }, _SHDate_setMinutes = function _SHDate_setMinutes(minutes, seconds = false, milliseconds = false, isUTC = false) {
        milliseconds = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, milliseconds, isUTC ? this.getUTCMilliseconds() : this.getMilliseconds());
        seconds = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, seconds, isUTC ? this.getUTCSeconds() : this.getSeconds());
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCMinutes(minutes, seconds, milliseconds)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setMinutes(minutes, seconds, milliseconds);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_timeSync).call(this);
        return this.getTime();
    }, _SHDate_setSeconds = function _SHDate_setSeconds(seconds, milliseconds = false, isUTC = false) {
        milliseconds = __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_isFalse).call(this, milliseconds, isUTC ? this.getUTCMilliseconds() : this.getMilliseconds());
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCSeconds(seconds, milliseconds)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setSeconds(seconds, milliseconds);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_timeSync).call(this);
        return this.getTime();
    }, _SHDate_setMilliseconds = function _SHDate_setMilliseconds(milliseconds, isUTC = false) {
        isUTC
            ? __classPrivateFieldGet(this, _SHDate_date, "f").setUTCMilliseconds(milliseconds)
            : __classPrivateFieldGet(this, _SHDate_date, "f").setMilliseconds(milliseconds);
        __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_timeSync).call(this);
        return this.getTime();
    }, Symbol.toPrimitive)](hint) {
        if (hint === "number") {
            return this.getTime() - __classPrivateFieldGet(this, _SHDate_config, "f").time_difference_server;
        }
        else if (hint === "string" || hint === "default") {
            return `SHDate ${this.toString()}`;
        }
        return this.toString();
    }
    toLocaleTimeString(locales, options) {
        return __classPrivateFieldGet(this, _SHDate_date, "f").toLocaleTimeString(locales, options);
    }
    toLocaleDateString(locales, options) {
        return __classPrivateFieldGet(this, _SHDate_date, "f").toLocaleDateString(locales, options);
    }
    toLocaleString(locales, options) {
        return __classPrivateFieldGet(this, _SHDate_date, "f").toLocaleString(locales, options);
    }
    setTimeServerDiff(time) {
        __classPrivateFieldGet(this, _SHDate_config, "f").time_difference_server = time;
        __classPrivateFieldGet(this, _SHDate_date, "f").setTime(__classPrivateFieldGet(this, _SHDate_date, "f").getTime() - time);
    }
    getTimeServerDiff() {
        return __classPrivateFieldGet(this, _SHDate_config, "f").time_difference_server;
    }
    setTimeZone(time_zone) {
        __classPrivateFieldGet(this, _SHDate_config, "f").time_zone = time_zone;
    }
    getTimeZone() {
        return __classPrivateFieldGet(this, _SHDate_config, "f").time_zone;
    }
    setSHDateLanguage(language) {
        if (SHDateWord.check(language))
            __classPrivateFieldGet(this, _SHDate_config, "f").word_language = language;
        else
            throw new Error("setSHDateLanguage: " + language + " not found");
    }
    getSHDateLanguage() {
        return __classPrivateFieldGet(this, _SHDate_config, "f").word_language;
    }
    setFirstDayOfWeek(FDOW = 1) {
        if (FDOW >= 1 && FDOW <= 7)
            __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week = FDOW - 1;
        else
            throw new Error("setFirstDayOfWeek: " + FDOW + " less than 1 or more than 7");
        return;
    }
    getFirstDayOfWeek() {
        return __classPrivateFieldGet(this, _SHDate_config, "f").first_day_of_week;
    }
    getEquinoxOrSolstice() { }
    restTime(hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_restTime).call(this, hours, minutes, seconds, milliseconds, false);
    }
    restUTCTime(hours = 0, minutes = 0, seconds = 0, milliseconds = 0) {
        return __classPrivateFieldGet(this, _SHDate_instances, "m", _SHDate_restTime).call(this, hours, minutes, seconds, milliseconds, true);
    }
    setConfig(...args) {
        const config = Object.assign(Object.assign({}, __classPrivateFieldGet(this, _SHDate_config, "f")), args);
        this.setFirstDayOfWeek(config.first_day_of_week);
        this.setSHDateLanguage(config.word_language);
        this.setTimeZone(config.time_zone);
        this.setTimeServerDiff(config.time_difference_server);
    }
    clone() {
        return new _a(this);
    }
    copy() {
        return this.clone();
    }
    instance() {
        return this;
    }
    this() {
        return this.instance();
    }
    static getVersion() {
        return _a.VERSION;
    }
}
_a = SHDate, _SHDate_restTime = function _SHDate_restTime(hours = 0, minutes = 0, seconds = 0, milliseconds = 0, isUTC = false) {
    isUTC
        ? this.setUTCHours(hours, minutes, seconds, milliseconds)
        : this.setHours(hours, minutes, seconds, milliseconds);
    return [hours, minutes, seconds, milliseconds];
}, _SHDate_isFalse = function _SHDate_isFalse(data, defaultData) {
    if (data === false)
        return defaultData;
    return data;
};
SHDate.VERSION = "2.1.26";
SHDate.DAYS_IN_MONTH = [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    29
];
SHDate.DAYS_IN_MONTH_LEAP = [
    31,
    31,
    31,
    31,
    31,
    31,
    30,
    30,
    30,
    30,
    30,
    30
];
SHDate.DAY_OF_YEAR = [
    0,
    31,
    62,
    93,
    124,
    155,
    186,
    216,
    246,
    276,
    306,
    336
];
SHDate.DAYS_IN_YEAR = 365;
SHDate.DAYS_IN_YEAR_LEAP = 366;
SHDate.WEEKS_IN_YEAR = 52;
SHDate.WEEKS_IN_YEAR_LEAP = 53;
function toNumber(source, destination = "FA") {
    const EN = SHDateLanguage.getClass(SHDateLanguages.en_US).DIGIT;
    const FA = SHDateLanguage.getClass(SHDateLanguages.fa_IR).DIGIT;
    let digits;
    switch (destination.toUpperCase()) {
        case "FA":
        case "FA_IR":
            digits = FA;
            break;
        case "EN":
        case "EN_US":
            digits = EN;
            break;
        default:
            digits = FA;
            break;
    }
    EN.forEach((value, index) => {
        source = `${source}`.replace(value, digits[index]);
    });
    return `${source}`;
}
class SHDateWord extends SHDateLanguage {
    static getMeridienFullNames(H24, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).MERIDIEN_FULL_NAMES[H24 > 11 ? 1 : 0];
    }
    static getMeridienShortNames(H24, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).MERIDIEN_SHORT_NAMES[H24 > 11 ? 1 : 0];
    }
    static getMonthFullNames(month, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).MONTH_FULL_NAMES[month];
    }
    static getMonthShortNames(month, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).MONTH_SHORT_NAMES[month];
    }
    static getDayFullNames(dow, word_language = SHDateWord.LANGUAGE, FDOW = SHDateWord.FIRST_DAY_OF_WEEK) {
        return SHDateWord.getClass(word_language).DAY_FULL_NAMES[(dow + FDOW) % 7];
    }
    static getDayShortNames(dow, word_language = SHDateWord.LANGUAGE, FDOW = SHDateWord.FIRST_DAY_OF_WEEK) {
        return SHDateWord.getClass(word_language).DAY_SHORT_NAMES[(dow + FDOW) % 7];
    }
    static getSuffixNames(date, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).SuffixNames(date);
    }
    static getConstellationsFullNames(month, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).CONSTELLATIONS_FULL_NAMES[month];
    }
    static getAnimalsFullNames(year, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).ANIMALS_FULL_NAMES[year % 12];
    }
    static getSeasonFullNames(month, word_language = SHDateWord.LANGUAGE) {
        return SHDateWord.getClass(word_language).SEASON_FULL_NAMES[parseInt(((month + 1) / 3.1).toString())];
    }
    static getSolsticeFullNames(month, date, word_language = SHDateWord.LANGUAGE) {
        if (month === 2 && date === 31)
            return SHDateWord.getClass(word_language).SOLSTICE_FULL_NAMES[0];
        else if (month === 8 && date === 30)
            return SHDateWord.getClass(word_language).SOLSTICE_FULL_NAMES[1];
        return "";
    }
}
SHDateWord.word_language = SHDateWord.LANGUAGE;
SHDateWord.FIRST_DAY_OF_WEEK = 0;
